import React, { useCallback, useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { Examiner, ITaskGroup } from '../../../models/taskGroup.types';
import { unassignExamTaskGroupCoordinator } from '../../../services/exams/examiningTeam/examiningTeam.service';

export const UnassignExamTaskGroupCoordinatorDialog: React.FC<{
  itemId: string;
  examiner: Examiner;
  taskGroup: ITaskGroup;
  onSuccess: () => void;
  onFailure: () => void;
}> = (props) => {
  const [open, setOpen] = useState<boolean>(true);
  const [successPromptOpened, setSuccessPromptOpened] = useState<boolean>(false);
  const [failurePromptOpened, setFailurePromptOpened] = useState<boolean>(false);

  const getPromptMainText = () => {
    return 'Usunięcie przypisanej funkcji KGZ Egzaminatorowi: ';
  };

  const getPromptSubTexts = (isSuccess?: boolean) => {
    return [
      {
        text: true ? props.examiner.firstName + ' ' + props.examiner.lastName : '',
      },
      {
        text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
        isBold: true,
      },
    ];
  };

  const unassignKGZRole = useCallback(() => {
    unassignExamTaskGroupCoordinator(props.itemId).then(
      () => {
        setOpen(false);
        setSuccessPromptOpened(true);
      },
      () => {
        setOpen(false);
        setFailurePromptOpened(true);
      },
    );
  }, [props.itemId]);

  return (
    <>
      <Prompt
        open={open}
        type="confirmation"
        onConfirm={unassignKGZRole}
        onCancel={props.onFailure}
        mainActionButtonText="TAK"
        mainText="Czy na pewno chcesz usunąć przypisaną funkcję KGZ Egzaminatorowi:"
        subTexts={[
          {
            text: props.examiner.firstName + ' ' + props.examiner.lastName,
          },
        ]}
      />
      <Prompt
        type="success"
        isBold={true}
        open={successPromptOpened}
        mainText={getPromptMainText()}
        subTexts={getPromptSubTexts(true)}
        onConfirm={props.onSuccess}
        mainActionButtonText="POWRÓT DO LISTY"
      />
      <Prompt
        type="error"
        isBold={true}
        open={failurePromptOpened}
        mainText={getPromptMainText()}
        subTexts={getPromptSubTexts(false)}
        onConfirm={props.onFailure}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};

export default UnassignExamTaskGroupCoordinatorDialog;
